import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigService } from '@core/config/config.service';
import { AuthService } from '@core/guards/auth.service';
import { HttpService } from '@core/http/http.service';
import { ActivityLog } from '../models/activities-log/activity-log.model';


@Injectable({
  providedIn: 'root'
})
export class ActivityService extends HttpService {

  constructor(protected http: HttpClient, protected config: ConfigService, protected authService: AuthService) {
    super(http, config, authService, 'activities');
  }

  getActivities(): Observable<ActivityLog[]> {
    return this.invokeGet<ActivityLog[]>();
  }

  getActivityDetail(activityId: number): Observable<ActivityLog[]> {
    return this.invokeGet<ActivityLog[]>(`${activityId}`);
  }

  getInvoicesActivity(from?: string, to?: string): Observable<Blob> {
    return this.invokeGetFile('export-invoices-activities', { from, to });
  }
}
